import React from 'react';
import { ImageIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { BeforeAfterSlider } from '../BeforeAfterSlider';
import { coach } from '../../config/coach';

const clients = coach.results.clients || [];

const ClientCard = ({ client }) => (
  <div className="glass-card p-4 sm:p-5" data-testid="client-transformation-card">
    <BeforeAfterSlider
      before={client.before}
      after={client.after}
      beforePos={client.beforePos}
      afterPos={client.afterPos}
    />
    <p className="mt-4 text-center text-white/40 text-[11px] uppercase tracking-[0.25em]">
      Client Transformation
    </p>
  </div>
);

// Neutral placeholder shown only when no real transformations are configured.
const PlaceholderCard = () => (
  <div className="glass-card p-4 sm:p-5">
    <div className="relative w-full aspect-[3/4] overflow-hidden rounded-xl border border-dashed border-white/15 bg-white/[0.03] flex flex-col items-center justify-center gap-2">
      <ImageIcon className="w-7 h-7 text-white/20" strokeWidth={1.4} />
      <span className="text-[10px] uppercase tracking-[0.2em] text-white/40">Coming soon</span>
    </div>
    <p className="mt-4 text-center text-white/40 text-[11px] uppercase tracking-[0.25em]">
      Client Transformation
    </p>
  </div>
);

const ResultsSection = () => {
  const hasClients = clients.length > 0;
  const cards = hasClients ? clients : [null, null, null];

  return (
    <section id="results" className="relative bg-black py-24 sm:py-32" data-testid="results-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="text-center max-w-xl mx-auto mb-12 sm:mb-14">
          <Reveal><span className="kicker justify-center before:hidden">{coach.results.kicker}</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-bold uppercase text-white tracking-tight leading-[0.9] text-5xl sm:text-6xl lg:text-7xl mt-4">
              {coach.results.heading}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-white/55 text-sm sm:text-base">{coach.results.sub}</p>
          </Reveal>
        </div>

        <div className="grid gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3 max-w-5xl mx-auto">
          {cards.map((client, i) => (
            <Reveal key={i} delay={0.1 + i * 0.05}>
              {client ? <ClientCard client={client} /> : <PlaceholderCard />}
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-10 text-center text-white/35 text-xs sm:text-sm tracking-wide">
            Drag any slider to see the transformation. More added regularly.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default ResultsSection;
